import React, { useEffect, useState } from 'react'
import Header from '../Header'
import Menus from './Menus'
import Profile from './Profile'
import './myspace.css';
import { Col, Container, Image, Row } from 'react-bootstrap';
import Modal from '../Modal';
function MySpace() {
  const user_id = localStorage.getItem('dastaan__user_id') !== undefined ? localStorage.getItem('dastaan__user_id') : 0;
  const [showModal, setShowModal] = useState(false); // 👈 for modal control
  const [dw, setWidth] = useState(0)
  useEffect(() => {
    const w = window.innerWidth
    setWidth(w)
  }, [])
  return (
    <>
      {
        dw <= 768 ? <Header /> : ''
      }
      {user_id > 0 ? (<>
        <Profile width={dw} />
        <Menus width={dw} /></>) :
        (
          <>
            <Container className={`text-center ${dw > 768 && 'ml-10'}`} style={{ marginTop: dw > 768 ?  "8%" : "30%", marginBottom: dw > 768 ?  "8%" : "30%" }}>
              <Row>
                <Col md={12} xs={12}>
                  <Image src={`${process.env.PUBLIC_URL}/images/logout_profile.png`} />
                </Col>
                <Col md={12} xs={12}>
                  <span className='mt-10' style={{ fontSize: "20px", fontWeight: 600 }}>Login to Dastaan</span>
                </Col>
                <Col md={12} xs={12} className='mt-5 '>
                  <span className='login_btn ' onClick={() => setShowModal(true)}>Log In</span>
                </Col>
              </Row>
            </Container>
            <Modal show={showModal} onClose={() => setShowModal(false)} />
          </>
        )
      }
    </>
  )
}
export default MySpace